import { Button, ErrorBoundary, Icon, Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';

import { BlockedResource } from '../../constants';

import { CardBlock } from './components/CardBlock';

interface BlockedResourceListProps {
  title: string;
  data: BlockedResource[];
  onNewBlock: () => void;
  onRemoveBlock: (id: number) => void;
  isLoading: boolean;
  error: boolean;
  onRefresh: () => void;
}

export const BlockedResourceList = ({
  title,
  data,
  onNewBlock,
  onRemoveBlock,
  error,
  onRefresh,
  isLoading = false,
}: BlockedResourceListProps) => {
  if (error) {
    return <ErrorBoundary onRefresh={onRefresh} />;
  }

  return (
    <Shadow borderRadius={BoxBorder.heavy} level={2} my={Spacing['stack.xxxs']}>
      <VStack px={Spacing['inline.xxxs']} space={Spacing['stack.xxxs']}>
        <HStack alignItems="center" justifyContent="space-between" pt={Spacing['stack.xxxs']}>
          <Text
            fontSize={Typography['fontsize.md']}
            variant="regular"
            color="brand.primary.darkest">
            {title}
          </Text>
          <Button
            variant="textLink"
            colorScheme="brand"
            _text={{
              color: 'feedback.error.default',
              fontWeight: 'semibold',
            }}
            leftIcon={<Icon name="Cancel" color={Color['feedback.error.default']} size="xs" />}
            onPress={onNewBlock}>
            Novo bloqueio
          </Button>
        </HStack>

        <Box width="full" borderTopWidth={1} borderColor={Color['neutral.lightest']} />

        <CardBlock isLoading={isLoading} data={data} onRemoveBlock={onRemoveBlock} />
      </VStack>
    </Shadow>
  );
};
